import z from 'zod'

// Utility function to check if an object is a Zod schema
export const isZodSchema = (schema: unknown): schema is z.ZodTypeAny => {
  return typeof schema === 'object' && schema !== null &&
    'safeParse' in schema &&
    typeof (schema as { safeParse?: unknown }).safeParse === 'function'
}
